import React from "react";
import { ButtonBlock } from "./styled";
import { Text } from "./../../../styled";
import AnimatedDots from "../AnimatedDots/AnimatedDots";

const Button = (props) => {
  const {
    text,
    type,
    action,
    disabled,
    isGradient,
    isLoading,
    icon,
    fontSize,
    fontWeight,
    style,
    isOpacityDisabled,
    color,
  } = props;

  const handleButtonClick = () => {
    action();
  };

  return (
    <ButtonBlock
      type={type}
      isGradient={isGradient}
      onClick={handleButtonClick}
      className={disabled ? "disabled" : null}
      style={style}
      isOpacityDisabled={isOpacityDisabled}
    >
      {isLoading ? (
        <ButtonBlock.Loading>
          <AnimatedDots />
        </ButtonBlock.Loading>
      ) : (
        <ButtonBlock.Wrapper>
          {icon ? <img src={icon} alt="icon" style={{ maxWidth: 72 }} /> : null}
          <Text.Button
            style={{ fontSize: fontSize, color: color, fontWeight: fontWeight }}
            type={type}
          >
            {text}
          </Text.Button>
        </ButtonBlock.Wrapper>
      )}
    </ButtonBlock>
  );
};

export default Button;
